import React from 'react';

import logoInterOdonto from '../../../../assets/logo1.png';
import logoNotredame from '../../../../assets/logo2.png';
import FieldDefault from '../../../../components/PDFPage/Inputs/Default';

import * as S from './styles';
import { questionsFormDeclaracaoSaude } from './utils';

function TableQuestions({ numRows = 5, ...rest }) {
    return (
        <S.TableQuestions {...rest}>
            <thead>
                <tr>
                    <th>Item (pergunta) </th>
                    <th>Tit./Nº do dependente/agregado</th>
                    <th>Data/evento - Descrição/Esclarecimento;CID</th>
                    <th>Uso da operadora</th>
                </tr>
            </thead>
            <tbody>
                {Array.from(' '.repeat(numRows)).map((el, index) => (
                    <tr key={index}>
                        <td aria-label="pass" />
                        <td aria-label="pass" />
                        <td aria-label="pass" />
                        <td aria-label="pass" />
                    </tr>
                ))}
            </tbody>
        </S.TableQuestions>
    );
}

function Header() {
    return (
        <>
            <S.Header>
                <S.LogoGroup>
                    <S.Logo src={logoNotredame} />

                    <S.Divisor />

                    <S.Logo src={logoInterOdonto} />
                </S.LogoGroup>

                <S.NumMotionLaw>
                    <span style={{ width: '60px' }}>Lei nº 9.656, de 3/6/1998</span>

                    <S.DivisorLaw />

                    <section>
                        <label>Nº da Proposta de Adesão</label>
                        <span>321313</span>
                    </section>
                </S.NumMotionLaw>
            </S.Header>

            <S.TitleBar>Declaração de Saúde</S.TitleBar>
        </>
    );
}

function CartaDeclaracaoSaude({ form: { dataTitular } }) {
    return (
        <>
            <S.Container>
                <Header />

                <S.Label>INFORMAÇÕES IMPORTANTES</S.Label>

                <S.Topics>
                    <li>
                        <b>1.</b> A Declaração de Saúde consiste no preenchimento do formulário abaixo para registro de
                        informações sobre as doenças ou lesões de que você saiba ser portador ou sofredor e das quais
                        tenha conhecimento, no momento da contratação ou adesão contratual.{' '}
                    </li>

                    <li>
                        <b>2.</b> Você terá o direito de preencher essa Declaração de Saúde mediante entrevista
                        qualificada, orientado por um médico pertencente à lista de profissionais da rede credenciada ou
                        referenciados da NotreDame Intermédica, sem qualquer onus. Caso você opte por ser orientado por
                        médico nâo pertencente à lista de profissionais da rede assistencial da NotreDame Intermédica,
                        podera fazé-lo, desde que você se responsabilize pelos honorários médicos deste profissional.{' '}
                    </li>
                    <li>
                        <b>3.</b> Conforme disposto na RN 162 da Agência Nacional de Saúde Suplementar - ANS, define-se
                        como: a) Cobertura Partial Temporária (CPT): aquela que admite, por um periodo ininterrupto de
                        até 24 meses, a partir da data da contratação ou adesâo ao piano de saúde, a suspensâo da
                        cobertura de Procedimentos de Alta Complexidade (PAC), leitos de alta tecnologia e procedimentos
                        cirúrgicos, desde que relacionados exclusivamente as doenças ou lesoes preexistentes declaradas
                        pelo beneficiario ou seu representante legal; b) Agravo: qualquer acréscimo no valor da
                        contraprestação paga ao piano de saude, para que o beneficiario tenha direito integral à
                        cobertura contratada, para a doença ou lesão preexistente declarada, apos os prazos de carências
                        contratuais, de acordo com as condiços negociadas entre a operadora e o beneficiário.
                    </li>
                    <li>
                        <b>4.</b> A omissâo de informação sobre a existência de doença ou lesâo preexistente, conhecida
                        por vocé e nâo declarada neste formulario, pode acarretar consequências previstas na legislação,
                        de rescisâo contratual e de responsabilidades por despesas realizadas com os procedimentos que
                        seriam objetos de CPT, caso estes fatos venham a ser comprovados junto à ANS.
                    </li>
                    <li>
                        <b>5.</b> Às doenças ou lesoes declaradas nesta Declaraçâo de Saude é oferecida Cobertura
                        Parcial Temporária — CPT pela NotreDame Intermédica, de acordo com o prazo e as condiçoes de
                        suspensâo de cobertura, conforme descrito no item 3.
                    </li>
                </S.Topics>

                <hr />

                <FieldDefault
                    style={{ borderTop: 'none', borderLeft: 'none', width: '100%' }}
                    slots={55}
                    label="Nome do Titular (obrigatoriamente nome completo)"
                    value={dataTitular.fullName.value}
                />

                <S.TitleForm>Deve ser preenchido pelo Titular e Representante legal</S.TitleForm>

                <S.FormContainer>
                    <S.FormHeader />

                    <S.FormRow>
                        <S.QuestionContainer style={{ borderBottom: 'none' }}>
                            <S.QuestionNumber />
                            <S.QuestionContent />
                        </S.QuestionContainer>

                        <S.Answers>
                            <S.Answer style={{ borderBottom: 'none' }}>Titular</S.Answer>
                            <S.Answer style={{ width: '140px' }}>Dependente/Agregado</S.Answer>
                        </S.Answers>
                    </S.FormRow>

                    <S.FormRow>
                        <S.QuestionContainer style={{ borderTop: 'none' }}>
                            <S.QuestionNumber />
                            <S.QuestionContent />
                        </S.QuestionContainer>

                        <S.Answers>
                            <S.Answer style={{ borderTop: 'none' }} />
                            <S.Answer>1</S.Answer>
                            <S.Answer>2</S.Answer>
                            <S.Answer>3</S.Answer>
                            <S.Answer>4</S.Answer>
                        </S.Answers>
                    </S.FormRow>

                    {questionsFormDeclaracaoSaude.map((question, index) => (
                        <S.FormRow>
                            <S.QuestionContainer>
                                <S.QuestionNumber>{index + 1}. </S.QuestionNumber>

                                <S.QuestionContent>{question}</S.QuestionContent>
                            </S.QuestionContainer>

                            <S.Answers>
                                <S.Answer />
                                <S.Answer />
                                <S.Answer />
                                <S.Answer />
                                <S.Answer />
                            </S.Answers>
                        </S.FormRow>
                    ))}

                    <S.FormRow>
                        <S.Answers checks>
                            <S.Answer>Informar peso:</S.Answer>
                            <S.Answer>Titular</S.Answer>
                            <S.Answer>Dep./Agr.(1)</S.Answer>
                            <S.Answer>Dep./Agr.(2)</S.Answer>
                            <S.Answer>Dep./Agr.(3)</S.Answer>
                            <S.Answer>Dep./Agr.(4)</S.Answer>
                        </S.Answers>
                    </S.FormRow>

                    <S.FormRow>
                        <S.Answers checks>
                            <S.Answer>Informar altura:</S.Answer>
                            <S.Answer>Titular</S.Answer>
                            <S.Answer>Dep./Agr.(1)</S.Answer>
                            <S.Answer>Dep./Agr.(2)</S.Answer>
                            <S.Answer>Dep./Agr.(3)</S.Answer>
                            <S.Answer>Dep./Agr.(4)</S.Answer>
                        </S.Answers>
                    </S.FormRow>

                    <S.FormFooter>
                        Caso você e/ou seu(s) dependente(s) / agregado(s) apresente(m) alguma(s) das situações
                        anteriores, por favor, especifique(m) datas, tratamentos, realizações de cirurgias, situação
                        atual ou demais dados que considerar(em) importantes para avaliação medica e o número do
                        dependente / agregado. Se dispuser do relatório médico ou laudo de exames e cirurgias a respeito
                        da doença referida, junte a esta Declaração de Saúde.
                    </S.FormFooter>
                </S.FormContainer>

                <TableQuestions numRows={13} />
            </S.Container>

            <S.Container>
                <Header />

                <TableQuestions numRows={10} style={{ marginBottom: '15px' }} />

                <S.Topics style={{ fontSize: '8px' }}>
                    <li>Eu, proponente titular, declaro que:</li>
                    <br />
                    <li>
                        Entendi o conteúdo das informações importantes e de todas as perguntas da Declaração de Saúde, e
                        dispensei orientação médica para respondê-las, assumindo total responsabilidade pelas
                        informações por mim prestadas. Aceitei oferta de Cobertura Parcial Temporária - CPT em relação
                        às doenças e lesões declaradas neste documento. Autorizo a operadora a solicitar, a qualquer
                        tempo, a médicos, hospitais, clínicas e laboratórios, exames, prontuários e informações
                        necessárias para a elucidação de qualquer assunto que se relacione com a presente Declaração de
                        Sáude. Informações de saúde relativas a mim e a meu(s) dependente(s)/agregado(s) são verdadeiras
                        e completas, e foram espontaneamente fornecidas, estando ciente de que a omissão de fatos e/ou o
                        preenchimento incorreto desta declaração poderá acarretar as consequências previstas na
                        legislação de rescisão contratual e de responsabilidade do beneficiário por despesas realizadas
                        com os procedimentos que seriam objetos de CPT, caso venha a ser comprovada junto à ANS.
                    </li>
                    <br />
                    <li>
                        Nos termos do artigo 16 da Lei n° 9.656/98 e observada a Súmula 27 da ANS, tenho ciência de que
                        a NotreDame Intermédica reserva-se direito de exigir a realização de entrevista médica
                        qualificada como condição de aceitação desta contratação, em especial para as hipóteses de
                        conflito entre as informações constantes no item 11 em relação ao peso e altura informados na
                        Declaração de Saúde, de forma a esclarecer o conhecimento ou não quanto à patologia de obesidade
                        mórbida.
                    </li>
                    <br />
                    <li>
                        1. A Operadora poderá realizar a coleta, uso, armazenamento, tratamento e proteção de meus dados
                        pessoais e dados pessoais dos meus dependentes, incluindo, mas não se limitando as doenças ou
                        lesões preexistentes declaradas, para ns cumprimento de obrigações perante os órgãos
                        reguladores, como a ANS. Estou ciente de que estes dados serão utilizados com o objetivo
                        identicar os prazos de carência ou cobertura parcial temporária que poderão ser imputados ao
                        contrato. Para mais informações, acesse https://www.gndi.com.br/politicas-de-privacidade.
                    </li>
                    <br />
                    <li>
                        2. Autorizo a Operadora a solicitar, a qualquer tempo, a médicos, hospitais, clínicas,
                        laboratórios exames, prontuários e outras informações necessárias a quaisquer esclarecimentos
                        relacionados a esta Declaração de Saúde, a mim, através de contato telefônico, ou outros meios
                        de comunicação.
                    </li>
                    <br />
                </S.Topics>

                <S.Signature>
                    <S.Field style={{ width: '30%' }}>
                        <label>Local e Data</label>
                        <div />
                    </S.Field>
                    <S.Field style={{ width: '40%' }}>
                        <label>Assinatura do Titular ou Representante Legal</label>
                        <div />
                    </S.Field>
                    <S.Field style={{ width: '30%' }}>
                        <label>Médico/Carimbo CRM</label>
                        <div />
                    </S.Field>
                </S.Signature>
            </S.Container>
        </>
    );
}

export default CartaDeclaracaoSaude;
